import React from 'react';

import 'semantic-ui-react';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { BrowserRouter, Route, Routes as RoutesDom, Navigate } from 'react-router-dom';

import DashboardRoute from './DashboardRoute';
import LocationListener from './LocationListener';
import Routing from '../../libs/routing';
import { getHelpCenterUrl } from '../../libs/routing/display';
import NotFound from '../core/404';
import GMBPage from '../core/GMBPage';
import LoginPage from '../core/LoginPage';
import WaaSPage from '../core/SignUpPage/SignUpPage';
import Redirect from '../modules/foundation/components/Redirect/Redirect';
import useBranding from '../modules/foundation/hooks/use-branding';
import { BRAND_IDENTITIES } from '../modules/foundation/hooks/use-branding/useBranding.constants';
import MaintenanceWindowPage from '../pages/MaintenanceWindowPage';

function HelpCenterRedirect() {
  const { isGlammatic } = useBranding();
  const brandIdentity = isGlammatic ? BRAND_IDENTITIES.GLAMMATIC : BRAND_IDENTITIES.FISHERMAN;

  return <Redirect url={getHelpCenterUrl(brandIdentity)} />;
}

function getRoute(
  rootRoutePath,
  {
    completePath,
    component,
    hasToolbar,
    roles,
    permissions,
    youtubeId,
    categories,
    businessTypes,
    featureFlags,
    whitelistFeatureFlags,
    featureSets,
    shouldDisplay,
    recipeExclusionList,
  },
) {
  return (
    <Route
      path={completePath}
      element={
        <DashboardRoute
          path={completePath}
          component={component}
          rootRoutePath={rootRoutePath}
          hasToolbar={hasToolbar}
          roles={roles}
          permissions={permissions}
          youtubeId={youtubeId}
          categories={categories}
          businessTypes={businessTypes}
          featureFlags={featureFlags}
          whitelistFeatureFlags={whitelistFeatureFlags}
          featureSets={featureSets}
          shouldDisplay={shouldDisplay}
          recipeExclusionList={recipeExclusionList}
        />
      }
    />
  );
}

function getRoutes(rootRoutePath, routes) {
  return routes.map((route) => getRoute(rootRoutePath, route));
}

function getDashboardRoutes(rootRoutePath) {
  const routes = Routing.getFlattenedRoutes([rootRoutePath]);
  return getRoutes(rootRoutePath, routes);
}

function getAllDashboardRoutes() {
  return Routing.getRoutes().map(({ path: rootRoutePath }) => getDashboardRoutes(rootRoutePath));
}

export default function Routes() {
  const { maintenanceWindow } = useFlags();

  if (maintenanceWindow) {
    return (
      <BrowserRouter>
        <MaintenanceWindowPage />
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <LocationListener>
        <RoutesDom>
          {getAllDashboardRoutes()}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login/" element={<LoginPage />} />
          <Route path="/help/" element={<HelpCenterRedirect />} />
          <Route path="/internal/sign-up/" element={<WaaSPage />} />
          <Route path="/sign-up/" element={<WaaSPage />} />
          <Route path="/billing/" element={<Navigate to="/account/billing" />} />
          <Route path="/gmb" element={<GMBPage />} />
          <Route element={<NotFound />} />
        </RoutesDom>
      </LocationListener>
    </BrowserRouter>
  );
}
